import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingBookButton from './components/FloatingBookButton';
import Home from './pages/Home';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingBookButton />
      </div>
    </BrowserRouter>
  );
}

export default App;